export const advancedActions = "Uyc";
export const customizeActions = "Vyc";
export const emojiTooltip = "Wyc";
export const itemHeaderLike = "Xyc";
export const itemHeaderReplyByMeeting = "Yyc";
export const itemHeaderDelete = "Zyc";
export const itemHeaderAddToSafeSenders = "_yc";
export const itemHeaderMarkAsPhishing = "$yc";
export const itemHeaderReportPhishing = "azc";
export const itemHeaderViewMessageSource = "bzc";
export const itemHeaderDownload = "czc";
export const itemHeaderViewMessageDetails = "dzc";
export const messageSafety = "ezc";
export const none = "fzc";
export const otherAddins = "gzc";
export const otherReplyActions = "hzc";
export const proofingSettings = "izc";
export const quickUseLabel = "jzc";
export const readUnread = "kzc";
export const replyByImSurfaceActionLabel = "lzc";
export const replyAllByImSurfaceActionLabel = "mzc";
export const setDictationLanguage = "nzc";
export const toggleDarkCompose = "ozc";
export const toggleDictationToolTip = "pzc";
export const viewActions = "qzc";
export const createFluidDocument = "rzc";
export const setReaction = "szc";
export const forwardEmailAsAttachment = "tzc";
export const findTimeTooltip = "uzc";
export default {advancedActions,customizeActions,emojiTooltip,itemHeaderLike,itemHeaderReplyByMeeting,itemHeaderDelete,itemHeaderAddToSafeSenders,itemHeaderMarkAsPhishing,itemHeaderReportPhishing,itemHeaderViewMessageSource,itemHeaderDownload,itemHeaderViewMessageDetails,messageSafety,none,otherAddins,otherReplyActions,proofingSettings,quickUseLabel,readUnread,replyByImSurfaceActionLabel,replyAllByImSurfaceActionLabel,setDictationLanguage,toggleDarkCompose,toggleDictationToolTip,viewActions,createFluidDocument,setReaction,forwardEmailAsAttachment,findTimeTooltip};